export default "__VITE_ASSET__DdyInA59__"